<template>
  <div>
    <div class="DialogToast" @click="hiddenDialogToast"></div>
    <div class="mainBox">
      <div class="content">
        <div class="title">{{ title }}</div>
        <div class="text" v-html="content"></div>
      </div>
      <img @click="hiddenDialogToast" src="../assets/images/close.png" alt srcset />
    </div>
  </div>
</template>
<script>
import request from '@/assets/js/request'
export default {
  props: {
    id: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      title: '',
      content: '',
      isShow: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      if (this.id == 3) this.title = '会员服务协议'
      if (this.id == 2) this.title = '隐私政策'
      let res = await request('/gateway/dictionary/dictionary/page/get', 'get', {
        id: this.id
      })
      this.content = res.data.cfgJson
    },
    hiddenDialogToast () {
      this.$parent.showDialogToast()
    }
  }
}
</script>
<style lang="scss" scoped>
.DialogToast {
  position: fixed;
  z-index: 998;
  background: #000;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  touch-action: none;
  opacity: 0.5;
}
.mainBox {
  position: fixed;
  z-index: 999;
  // background: #000;
  width: 90vw;
  height: 70vh;
  left: 50%;
  top: 50%;
  // color: #fff;
  font-size: 16px;
  transform: translate(-50%, -50%);
  .content {
    width: 100%;
    height: calc(100% - 10vw - 30px);
    background: #fff;
    overflow: hidden;
    touch-action: none;
    .title {
      font-size: 16px;
      margin: 15px 0 0;
      height: 20px;
      text-align: center;
    }
    .text {
      text-align: left;
      font-size: 14px;
      margin: 15px 15px;
      height: calc(100% - 66px);
      overflow: auto;
    }
  }
  img {
    width: 10vw;
    height: auto;
    margin: 20px auto 0;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DialogToast.vue